const buildSidechainContext = ({
  workspace,
  event,
  template,
  user,
  windowLocation,
} = {}) => ({
  workspace: {
    _id: workspace?._id,
    name: workspace?.name,
    identity: workspace?.identity,
    integrations: {
      ...(workspace?.integrations || {}),
      stripe: {
        isEnabled: workspace?.integrations?.stripe?.isEnabled,
      },
    },
  },
  windowLocation: windowLocation || null,
  event: event
    ? {
      ...event,
      collaborators: event.collaborators?.map((collaborator) => collaborator?._id) || [],
      __v: undefined,
    }
    : null,
  template: template || null,
  user: user
    ? {
      ...user,
      credits: undefined,
      updatedAt: undefined,
      __v: undefined,
    }
    : null,
});

export default buildSidechainContext;
